// extracted by mini-css-extract-plugin
export var errorsContainer = "_su-1";
export var link = "_su-0";